import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react'
import Results, { ResultItem } from '../Symbols/Results';

const formatBMI = amount => {
	if (amount <= 16.5) {
		return 'těžká podvýživa';
	} else if (amount <= 18.5) {
		return 'podváha';
	} else if (amount <= 25) {
		return 'ideální váha';
	} else if (amount <= 30) {
		return 'nadváha';
	} else if (amount <= 35) {
		return 'mírná obezita';
	} else if (amount <= 40) {
		return 'střední obezita';
	}
	return 'morbidní obezita';
};

const ResultNumber = styled('span')`
	font-style: italic;
	text-align: right;
`;

const Total = css`
	font-size: 18px;
	font-weight: bold;
`;

export default function StyledResult({ bmi }) {
	return (
		<Results data-cy="result">
			{[
				{ name: 'Vaše BMI je', value: bmi.bmi },
				{ name: 'To odpovídá', value: formatBMI(bmi.bmi), highlighted: true },
			].map(({ name, value, highlighted }) => {
				return (
					<ResultItem key={name} name={name} css={highlighted ? Total : null}>
						<ResultNumber>{value}</ResultNumber>
					</ResultItem>
				);
			})}
		</Results>
	);
}
